var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.897c1.094.508 1.915.983 2.462 1.425V0h1.076v14.322c.547-.442 1.368-.917 2.462-1.425v.86C4.752 14.79 3.83 15.87 3.23 17h-.46c-.582-1.13-1.505-2.211-2.77-3.243v-.86z",
    fill: "#456D45"
  })));
}
export default SvgArrow;